import React from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

export default function ServiceAreas({ data }) {
  const cities = (data?.items || []).filter((c) => c.enabled !== false);

  return (
    <section
      id="areas"
      data-testid="service-areas-section"
      className="relative py-24 sm:py-32 px-6 bg-[#FBF8F1] overflow-hidden"
    >
      {/* Decorative Massachusetts outline */}
      <svg
        className="absolute right-0 top-1/3 w-[400px] h-[300px] opacity-[0.10] pointer-events-none hidden lg:block"
        viewBox="0 0 200 130" fill="none"
      >
        <path
          d="M5 60 L20 50 L40 55 L60 45 L80 50 L100 40 L130 45 L160 35 L185 50 L195 70 L180 90 L150 95 L120 90 L90 100 L60 95 L35 105 L15 95 L5 80 Z"
          stroke="#D4AF37" strokeWidth="1.5" fill="rgba(212,175,55,0.06)"
        />
      </svg>

      <div className="relative max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-14"
        >
          {data?.eyebrow && (
            <p className="text-[11px] uppercase tracking-[0.32em] text-[#B8941F] font-semibold mb-4">{data.eyebrow}</p>
          )}
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A0A0A]">{data?.title}</h2>
          {data?.subtitle && (
            <p className="mt-3 text-gray-600 text-base sm:text-lg max-w-xl mx-auto">{data.subtitle}</p>
          )}
        </motion.div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4">
          {cities.map((city, i) => (
            <motion.div
              key={city.id || city.name}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.04 }}
              className="group bg-white border border-[#EFEAD8] rounded-2xl px-5 py-5 flex items-center gap-3 hover:border-[#D4AF37]/50 hover:shadow-[0_8px_24px_-12px_rgba(212,175,55,0.4)] transition-all cursor-default"
              data-testid={`area-card-${i}`}
            >
              <span className="w-9 h-9 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/30 flex items-center justify-center group-hover:bg-[#D4AF37]/20 transition-colors shrink-0">
                <MapPin className="w-4 h-4 text-[#B8941F]" />
              </span>
              <span className="font-display font-bold text-[#0A0A0A] text-sm sm:text-[15px]">{city.name}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
